import { reportRefuseToCollect } from "../actions"
import {
  FETCH_ALL_LOCKERS_STATUSES_SUCCESS,
  FETCH_ALL_LOCKERS_LAYOUT_SUCCESS,
  FIND_NEXT_AVAILABLE_CELL,
  ON_LOCKER_LISTENER_START_WITH_OPEN_ATTEMPT,
  ON_LOCKER_LISTENER_START_WITH_OPEN_ATTEMPT_SUCCESS_RESPONSE,
  ON_LOCKER_LISTENER_START_WITH_OPEN_ATTEMPT_FAIL,
  ON_LOCKER_LOCK_LISTENER_RESPONSE,
  ON_LOCKER_LOCK_LISTENER_FAIL_RESPONSE,
  RESET_ALL_REDUCERS,
  CLEAR_RECENTLY_CLOSED_LOCKER_DOOR,
  RESET_CELLS_ERRORS_OPEN_ATTEMPS,
  ON_GET_OPENED_LOCKERS_STATUS_RESPONSE,
  SET_CHOSEN_CELL,
  FETCH_AVAILABLE_LOCKERS_STATUSES_SUCCESS,
  ON_DRIVER_ORDER_COLLECTION_REQ_SUCCESS,
  ON_DRIVER_ORDER_COLLECTION_REQ_FAIL,
  ON_DRIVER_RETURNES_CLEAN_ORDER_REQ_FAIL,
  ON_DRIVER_RETURNES_CLEAN_ORDER_CANCEL_SUCCESS,
  ON_DRIVER_RETURNES_CLEAN_ORDER_CANCEL_FAIL,
  ON_CUSTOMER_RETURNES_ORDER_CANCEL_SUCCESS,
  ON_CUSTOMER_RETURNES_ORDER_CANCEL_FAIL,
  CLEAN_PUT_TO_LOCKER_ERROR,
  CLEAN_CANCEL_PUT_TO_LOCKER_ERROR,
  ON_DRIVER_RETURNES_CLEAN_ORDER_REQ_SUCCESS,
  ON_START_ORDER_LOADING,
  ON_CANCEL_ORDER_LOADING,
  ON_ERROR_NETWORK,
  ON_ERROR_TIMEOUT,
  FETCH_ALL_LOCKERS_STATUSES_REQUEST,
  ON_REPORT_REFUSE_TO_COLLECT_SUCCESS,
  ON_REPORT_REFUSE_TO_COLLECT_FAIL,
} from "../actions/types"

const INIT_STATE = {
  lockersData: [],
  lockersLayout: [],
  chosenSell: null,
  maxLockerNumber: 0,
  brokenLockersNumArr: [],
  nextAllAvailableCells: [],
  nextAvailableCellIndex: 0,
  nextAvailableCellNumber: null,
  openedLockersArr: [],
  errorLockersArr: [],
  recentClosedLockersArr: [],
  openingAttempsMap: {},
  recentOpenAttemptLockerNum: null,
  lockersWithOpenStatusFromHw: [],
  isNeedToReloadLockersStatuses: false,
  failPutToLocker: false,
  failCancelPutToLocker: false,
  isLoadingOrder: false,
  isLoadingOrderCancel: false,
  isAnyOrderToReturn: false,
  isAnyOrderToCollect: false,
  lockersToCollect: "",
  errorDriverCollect: false,
  lockersStatusesSuccess: false,
  reportRefuseToCollectSuccess: false,
  reportRefuseToCollectFail: false,
}

const LockersCellsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_LOCKERS_STATUSES_REQUEST:
      return {
        ...state,
        lockersStatusesSuccess: false,
      }
    case FETCH_AVAILABLE_LOCKERS_STATUSES_SUCCESS:
    case FETCH_ALL_LOCKERS_STATUSES_SUCCESS:
      return {
        ...handleLockersStatusesResponse(state, action.payload),
        lockersStatusesSuccess: true,
      }
    case FETCH_ALL_LOCKERS_LAYOUT_SUCCESS:
      return {
        ...state,
        lockersLayout: action.payload,
      }
    case FIND_NEXT_AVAILABLE_CELL:
      return handleFindNextAvailableCell(state)
    case ON_LOCKER_LISTENER_START_WITH_OPEN_ATTEMPT:
      return {
        ...state,
        openingAttempsMap: {
          ...state.openingAttempsMap,
          [action.payload]: state.openingAttempsMap[action.payload] + 1 || 1,
        },
        openedLockersArr: state.openedLockersArr.filter(
          (lock) => lock !== action.payload
        ),
        errorLockersArr: state.errorLockersArr.filter(
          (lock) => lock !== parseInt(action.payload)
        ),
        recentClosedLockersArr: state.recentClosedLockersArr.filter(
          (lock) => lock !== parseInt(action.payload)
        ),
        recentOpenAttemptLockerNum: parseInt(action.payload),
      }
    case ON_LOCKER_LISTENER_START_WITH_OPEN_ATTEMPT_SUCCESS_RESPONSE:
      return {
        ...state,
        openedLockersArr: [...state.openedLockersArr, parseInt(action.payload)],
        openingAttempsMap: {
          ...state.openingAttempsMap,
          [action.payload]: null,
        },
      }
    case ON_LOCKER_LISTENER_START_WITH_OPEN_ATTEMPT_FAIL:
      return {
        ...state,
        errorLockersArr: [...state.errorLockersArr, parseInt(action.payload)],
      }
    case ON_LOCKER_LOCK_LISTENER_RESPONSE:
      return {
        ...state,
        openedLockersArr: state.openedLockersArr.filter(
          (lock) => lock !== action.payload
        ),
        recentClosedLockersArr: [
          ...state.recentClosedLockersArr,
          parseInt(action.payload),
        ],
        // TODO - THINK AGAIN ONCE DRIVER LOCKER ERROR HANDLING HAS BEEN ADDED.. :
        errorLockersArr: state.errorLockersArr.filter(
          (lock) => lock !== parseInt(action.payload)
        ),
        openingAttempsMap: {
          ...state.openingAttempsMap,
          [action.payload]: null,
        },
      }
    case ON_LOCKER_LOCK_LISTENER_FAIL_RESPONSE:
      return {
        ...state,
        errorLockersArr: [...state.errorLockersArr, parseInt(action.payload)],
      }
    case CLEAR_RECENTLY_CLOSED_LOCKER_DOOR:
      return {
        ...state,
        recentClosedLockersArr: state.recentClosedLockersArr.filter(
          (lock) => lock !== parseInt(action.payload)
        ),
      }
    case RESET_CELLS_ERRORS_OPEN_ATTEMPS:
      return {
        ...state,
        openedLockersArr: [],
        errorLockersArr: [],
        recentClosedLockersArr: [],
        openingAttempsMap: {},
      }
    case ON_GET_OPENED_LOCKERS_STATUS_RESPONSE:
      return {
        ...state,
        lockersWithOpenStatusFromHw: action.payload,
      }
    case ON_CUSTOMER_RETURNES_ORDER_CANCEL_SUCCESS:
    case ON_DRIVER_RETURNES_CLEAN_ORDER_CANCEL_SUCCESS:
    case ON_DRIVER_ORDER_COLLECTION_REQ_SUCCESS:
      return {
        ...state,
        isNeedToReloadLockersStatuses: true,
        isLoadingOrder: false,
        isLoadingOrderCancel: false,
        errorDriverCollect: false,
      }
    case ON_DRIVER_ORDER_COLLECTION_REQ_FAIL:
      return {
        ...state,
        isNeedToReloadLockersStatuses: true,
        isLoadingOrder: false,
        isLoadingOrderCancel: false,
        errorDriverCollect: true,
      }

    case ON_START_ORDER_LOADING:
      return {
        ...state,
        isLoadingOrder: true,
      }
    case ON_CANCEL_ORDER_LOADING:
      return {
        ...state,
        isLoadingOrderCancel: true,
      }

    case ON_ERROR_NETWORK:
    case ON_ERROR_TIMEOUT:
    case ON_DRIVER_RETURNES_CLEAN_ORDER_REQ_SUCCESS:
      return {
        ...state,
        isLoadingOrder: false,
      }
    case ON_DRIVER_RETURNES_CLEAN_ORDER_REQ_FAIL:
      return {
        ...state,
        failPutToLocker: true,
        isLoadingOrder: false,
      }
    case ON_CUSTOMER_RETURNES_ORDER_CANCEL_FAIL:
    case ON_DRIVER_RETURNES_CLEAN_ORDER_CANCEL_FAIL:
      return {
        ...state,
        failCancelPutToLocker: true,
        isLoadingOrderCancel: false,
      }
    case CLEAN_PUT_TO_LOCKER_ERROR:
      return {
        ...state,
        failPutToLocker: false,
        isLoadingOrder: false,
      }
    case CLEAN_CANCEL_PUT_TO_LOCKER_ERROR:
      return {
        ...state,
        failCancelPutToLocker: false,
        isLoadingOrderCancel: false,
      }
    case RESET_ALL_REDUCERS:
      return {
        ...INIT_STATE,
        nextAllAvailableCells: state.nextAllAvailableCells,
      }
    case SET_CHOSEN_CELL:
      return {
        ...state,
        chosenCell: action.payload,
      }
    case ON_REPORT_REFUSE_TO_COLLECT_SUCCESS:
      return {
        ...state,
        reportRefuseToCollectSuccess: true,
        reportRefuseToCollectFail: false,
      }
    case ON_REPORT_REFUSE_TO_COLLECT_FAIL:
      return {
        ...state,
        reportRefuseToCollectFail: true,
        reportRefuseToCollectSuccess: false,
      }
    default:
      return state
  }
}

const handleLockersStatusesResponse = (state, respData) => {
  const lockersData = respData.data ? respData.data : respData
  lockersData.sort((a, b) => a.lockerName - b.lockerName)
  const nextAccesibleCells = lockersData.filter((itm) =>
    respData.serviceType && respData.serviceType === "laundry"
      ? itm.lockerStatus === 3 && itm.lockerType === 0 && itm.isAccessible
      : itm.lockerStatus === 3 && itm.isAccessible
  )
  const nextRegularCells = lockersData.filter((itm) =>
    respData.serviceType && respData.serviceType === "laundry"
      ? itm.lockerStatus === 3 && itm.lockerType === 0 && !itm.isAccessible
      : itm.lockerStatus === 3 && !itm.isAccessible
  )
  let nextAllAvailableCells
  if (respData.isNeedAccessibility) {
    nextAllAvailableCells =
      nextAccesibleCells.length > 0 ? nextAccesibleCells : nextRegularCells
  }
  if (!respData.isNeedAccessibility) {
    nextAllAvailableCells =
      nextRegularCells.length > 0 ? nextRegularCells : nextAccesibleCells
  }

  const nextCell = nextAllAvailableCells[0] || undefined
  const nextAvailableCellNumber = nextCell
    ? parseInt(nextCell.lockerName, 10)
    : undefined
  const maxLockerNumber = lockersData.reduce(
    (accu, { lockerName }) =>
      accu < parseInt(lockerName) ? parseInt(lockerName) : accu,
    0
  )
  const brokenLockersNumArr = lockersData
    .filter((itm) => itm.lockerStatus === 0 || itm.lockerStatus === 4)
    .map(({ lockerName }) => parseInt(lockerName))
  const isAnyOrderToReturn =
    lockersData.filter(
      (itm) =>
        !itm.disabled &&
        !itm.pickUpDisabled && //disabledToPickUp
        itm.order !== null &&
        itm.order.orderStatus === 13
    ).length > 0

  const isAnyOrderToCollect =
    lockersData.filter(
      (itm) =>
        itm.lockerStatus === 1 &&
        !itm.disabled &&
        !itm.pickUpDisabled &&
        itm.order !== null &&
        !itm.order.isRefused &&
        (itm.order.orderStatus === 13 || itm.order.orderStatus === 0)
    ).length > 0

  const lockersToCollect = lockersData
    .filter(
      (itm) =>
        itm.lockerStatus === 1 &&
        !itm.disabled &&
        !itm.pickUpDisabled &&
        itm.order !== null &&
        (itm.order.orderStatus === 13 || itm.order.orderStatus === 0)
    )
    .map((el) => el.lockerName)
    .join(", ")

  return {
    ...state,
    isNeedToReloadLockersStatuses: false,
    lockersData,
    nextAllAvailableCells,
    nextAvailableCellIndex: 0,
    nextAvailableCellNumber,
    maxLockerNumber,
    brokenLockersNumArr,
    isAnyOrderToReturn,
    isAnyOrderToCollect,
    lockersToCollect,
  }
}

const handleFindNextAvailableCell = (state) => {
  const { nextAvailableCellIndex, nextAllAvailableCells } = state
  const nextIndex = nextAvailableCellIndex + 1
  const nextCell = nextAllAvailableCells[nextIndex] || undefined
  const nextAvailableCellNumber = nextCell
    ? parseInt(nextCell.lockerName, 10)
    : undefined

  return {
    ...state,
    nextAvailableCellIndex: nextIndex,
    nextAvailableCellNumber,
  }
}

export default LockersCellsReducer
